import React from 'react';
import './HowItWorks.css';

const steps = [
  {
    number: '1',
    title: 'Choose your service',
    description: 'Pick from one-way, pool, rental, tours & more.',
  },
  {
    number: '2',
    title: 'See the fare upfront',
    description: 'Enter locations, dates and get an instant transparent quote.',
  },
  {
    number: '3',
    title: 'We confirm in 15 mins',
    description: 'Our team assigns a verified driver to your trip.',
  },
  {
    number: '4',
    title: 'Track and travel',
    description: 'Live GPS tracking from pickup to drop-off.',
  },
];

const HowItWorks = () => {
  return (
    <section className="how-it-works">
      <div className="how-it-works__container">
        <span className="how-it-works__eyebrow">Simple process</span>
        <h2 className="how-it-works__heading">Book in 3 minutes</h2>
        <p className="how-it-works__sub">
          No app needed. No registration. Just fill the form and we confirm your ride.
        </p>

        <div className="how-it-works__steps">
          <div className="how-it-works__line" />
          {steps.map((step, index) => (
            <div key={index} className="how-it-works__step">
              <div className="how-it-works__circle">
                <span className="how-it-works__number">{step.number}</span>
              </div>
              <h3 className="how-it-works__step-title">{step.title}</h3>
              <p className="how-it-works__step-desc">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
